var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$auth.loading && _vm.$auth.isAuthenticated)?_c('div',{attrs:{"id":"enterKey"}},[_c('b-container',{staticClass:"login"},[_c('p',[_vm._v("Please wait, logging you in...")])])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }